import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RequestResult } from '../core/request-result';
import { map, switchMap } from 'rxjs/operators';
import { ServiceBaseService } from '../core/service-base.service';
import { HarvestAmount } from './harvest-amount';
import { Observable } from 'rxjs';
import { Harvest } from './harvest';
import { LotService } from './lot.service';
import { sum, min, max } from 'lodash-es';


/**
 * Deals with HarvestAmount entries under a Harvest.
 */
@Injectable({
  providedIn: 'root'
})
export class HarvestAmountService {
  constructor(
    private http: HttpClient,
    private lotService: LotService,
    private serviceBase: ServiceBaseService
  ) {}

  getAmountsForLot(lot) {
    return this.http
      .get<RequestResult<HarvestAmount>>(
        this.serviceBase.getServiceBase() + '/harvestproduce?lotId=' + lot.id,
        this.serviceBase.getHeaders()
      )
      .pipe(map(v => v.result));
  }

  getAmountsForHarvest(harvest: Harvest) {
    return this.http
      .get<RequestResult<HarvestAmount>>(
        this.serviceBase.getServiceBase() + '/harvestproduce?harvestId=' + harvest.id,
        this.serviceBase.getHeaders()
      )
      .pipe(map(v => v.result));
  }

  getAmounts(searchParams?: {}): Observable<HarvestAmount[]> {
    const options = Object.assign(
      {
        params: searchParams
      },
      this.serviceBase.getHeaders()
    );

    return this.http
      .get<RequestResult<HarvestAmount>>(
        this.serviceBase.getServiceBase() + '/harvestproduce',
        options
      )
      .pipe(map(v => v.result));
  }

  assignHarvest(harvestAmount: HarvestAmount) {
    return this.http.post<RequestResult<HarvestAmount>>(
      this.serviceBase.getServiceBase() + '/harvestproduce',
      harvestAmount,
      this.serviceBase.getHeaders()
    );
  }

  removeAssignment(assignment: { id?: any }) {
    const id = assignment.id;
    return this.http.delete(
      this.serviceBase.getServiceBase() + `/harvestproduce/${id}`,
      this.serviceBase.getHeaders()
    );
  }

  updateLotTotals(lot) {
    return this.getAmountsForLot(lot).pipe(
      switchMap(amounts => {
        const totalAmount = sum(amounts.map(entry => entry.amount));
        const fromDate = min(amounts.map(entry => entry.originDate));
        const toDate = max(amounts.map(entry => entry.originDate));
        const lotUpdate = Object.assign(lot, {
          amount: totalAmount,
          harvestFromDate: fromDate,
          harvestToDate: toDate
        });
        return this.lotService.updateItem(lot.id, lotUpdate);
      })
    );
  }
}
